import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const SelectArrow = createSvgIcon(
  <path
    style={{ transform: 'scale(1.5)' }}
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7.29004 1.99708L7.99715 1.28998L8.70425 1.99708L11.7043 4.99708L10.9971 5.70419L7.99715 2.70419L4.99715 5.70419L4.29004 4.99708L7.29004 1.99708ZM7.29004 13.9971L4.29004 10.9971L4.99715 10.29L7.99715 13.29L10.9971 10.29L11.7043 10.9971L8.70425 13.9971L7.99715 14.7042L7.29004 13.9971Z"
  />,
  'SelectArrow'
)

export default SelectArrow
